// Scroll immédiat dès que la grille de produits existe
(function() {
  if (window.location.pathname.includes('/collections/') && window.location.pathname !== '/collections') {
    
    // Fonction qui cherche et scroll vers les produits
    function scrollToProducts() {
      const productGrid = document.querySelector('#main-collection-product-grid, .collection-product-grid, [id*="product-grid"]');
      if (productGrid) {
        productGrid.scrollIntoView({ behavior: 'auto', block: 'start' });
        return true;
      }
      return false;
    }
    
    // Essaie de scroller dès que possible
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToProducts);
    } else {
      scrollToProducts();
    }
  }
})();


